<!-- 企业详情 -->
<template>
  <div class="compony">
    <!-- 导航栏 -->
    <van-nav-bar
      title="企业详情"
      fixed
      placeholder
      z-index="10"
      @click-left="goBack(0)"
      @click-right="goBack(1)"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
      <template #right>
        <img src="@/assets/img/position/backHome.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 企业标题 -->
    <div class="com-title">
      <div class="title-left">
        <p class="title-tips">{{details.name}}</p>
        <div class="title-bit">
          <span>{{details.district_name}}</span>
          <span>{{details.nature_name}}</span>
          <span>{{details.trade_name}}</span>
        </div>
      </div>
      <img :src="details.logo" class="logos" />
    </div>
    <!-- 标签切换 -->
    <van-tabs v-model="activeName">
      <van-tab title="企业主页" name="a">
        <div class="page">
          <p class="com-introduction">公司介绍</p>
          <p class="com-content">{{details.content}}</p>
        </div>
        <!-- 图片展示 -->
        <div class="task-card">
          <div class="task-icon">公司环境</div>
          <!-- /* 这里是父盒子*/ -->
          <div class="wrapper">
            <!--  /* 这里是子盒子，即滚动区域*/ -->
            <ul class="cont" ref="cont">
              <li
                class="cont-item"
                @click="ImagePrev(index)"
                v-for="(item, index) in details.images"
                :key="index"
              >
                <div class="cont-img">
                  <img class="img" :src="item" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 联系方式 -->
        <div class="page">
          <p class="com-introduction">联系方式</p>
          <div class="page-tel">
            <div class="tel-top">
              <img :src="details.logo" class="head-img" />
              <span>{{details.contact}}</span>
            </div>
            <img
              src="@/assets/img/home/tel.png"
              class="head-img"
              @click="telphone(details.telphone)"
            />
          </div>
          <div class="page-address">
            <span>地址</span>
            <span>{{details.address}}</span>
          </div>
        </div>
      </van-tab>
      <van-tab title="在招职位" name="b">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="position">
              <!-- <router-link to="./positionDetails" v-for="(item, index) in 5" :key="index"> -->
                <div class="pos-item" v-for="(item, index) in list" :key="index" @click="goBack(2,item.job_id)">
                  <div class="pos-top">
                    <span>{{item.job_name}}</span>
                    <span>{{item.salary_type==0?`${item.min_salary}-${item.max_salary}`:'面议'}}</span>
                  </div>
                  <div class="pos-bits">
                    <span>{{item.district_name}}</span>
                    <span>{{item.experience==0?'不限':item.experience}}</span>
                    <span>{{item.education==0?'不限':item.education}}</span>
                    <span>{{item.amount==0?'不限':`招${item.amount}人`}}</span>
                  </div>
                </div>
              <!-- </router-link> -->
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getCompanyDetails, getPositionList } from "@/api/apiData";
import { ImagePreview, Toast } from "vant";
// import {mapState} from 'vuex'
export default {
  components: {},
  data() {
    return {
      activeName: "a", //默认展示
      details: "",
      page: 0,
      totalPages: 1,
      offset: 10,
      list: [],
      id: "",
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  computed: {
    // ...mapState(['token'])
  },
  methods: {
    goBack(val,id) {
      if (val == 0) {
        this.$router.back();
      } else if(val==1){
        this.$router.replace({
          name:'Index'
        });
      }else{
        this.$router.push({
          name:'positionDetails',
          query:{
            id:id
          }
        })
      }
    },
    // 图片预览
    ImagePrev(val) {
      ImagePreview({
        images: this.details.images,
        startPosition: val
      });
    },
    // 拨打电话
    telphone(val) {
      window.location.href = `tel:${val}`;
    },
    // 获取详情
    getDetails() {
      var that = this;
      var id = that.id;
      getCompanyDetails({ company_id: id }).then(res => {
        //(res);
        if (res.code == 1) {
          that.details = res.data;
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // 上拉加载
    onLoad(){
        this.getList()
    },
    // 下拉刷新
    onRefresh(){
      var that=this;
      that.page=0;
      that.totalPages=1;
      that.list=[];
      that.loading=false;
      that.finished=false;
      that.getList();
      setTimeout(()=>{
        that.refreshing=false
      },1500)
    },
    //获取在招职位
    getList() {
      var that = this;
      let { page, totalPages, offset, list, id } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        company_id: id
      };
      if (totalPages > page) {
        getPositionList(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            that.page = page + 1;
          }
          if(res.data.list.length==0){
            that.loading=false;
            that.finished=true;
            return false
          }
          if (that.list.length > list.length) {
            setTimeout(() => {
              that.loading = false;
            }, 2000);
          }
        });
      }else{
        that.loading=false;
        that.finished=true;
      }
    }
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getDetails();
    // this.getList();
  }
};
</script>
<style lang='less' scoped>
/deep/.van-tabs {
  margin-top: 0.2rem;
  background: #fff;
}
/deep/.van-nav-bar__placeholder {
  height: 0.8rem !important;
}
/deep/.van-tabs__nav--line {
  border-bottom: 0.01rem solid #ebedf0;
  padding-bottom: 0;
  .van-tab {
    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.45rem;
    color: rgba(51, 51, 51, 1);
  }
  .van-tab--active {
    color: #ff4343;
    font-weight: 600;
  }
  .van-tabs__line {
    bottom: 0;
    width: 50% !important;
    background: #ff4343;
  }
}
.compony {
  background: #f0f2f5;
  // 企业标题
  .com-title {
    padding: 0.32rem 0.36rem;
    display: flex;
    justify-content: space-between;
    background: #fff;
    .title-left {
      .title-tips {
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 0.48rem;
        color: rgba(51, 51, 51, 1);
      }
      .title-bit {
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.48rem;
        color: rgba(102, 102, 102, 1);
        margin-top: 0.16rem;
        span {
          margin-right: 0.2rem;
        }
      }
    }
    .logos {
      width: 1.06rem;
      height: 1.06rem;
    }
  }
  //   公司介绍
  .page {
    padding: 0.2rem 0.36rem;
    .com-introduction {
      font-size: 0.32rem;
      font-weight: bold;
      line-height: 0.45rem;
      color: rgba(51, 51, 51, 1);
      padding: 0.2rem 0;
    }
    .com-content {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.48rem;
      color: rgba(102, 102, 102, 1);
    }
    // 联系方式
    .page-tel {
      font-size: 0.28rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem 0;
      .tel-top {
        display: flex;
        align-items: center;
      }
      .head-img {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
        margin-right: 0.1rem;
      }
    }
    .page-address {
      font-size: 0.28rem;
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      display: flex;
      align-items: center;
      span:first-child {
        font-size: 0.26rem;
        font-weight: 400;
        color: rgba(128, 128, 128, 1);
        width: 12%;
        align-self: flex-start;
      }
    }
  }
  .page::after {
    content: "";
    display: block;
    border: 0.01rem solid rgb(229, 229, 229);
    width: 100%;
    margin-top: 0.4rem;
  }
  .page:last-child::after {
    content: "";
    display: block;
    border: 0;
    width: 100%;
    margin-top: 0.6rem;
  }
  //   公司环境
  .task-card {
    width: 100%;
    border-radius: 0.16rem;
    background: #fff;
    .card-items {
      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(54, 59, 77, 1);
      padding: 0.3rem 0.32rem;
    }
    //   项目图片
    .task-icon {
      font-size: 0.32rem;

      font-weight: 600;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      padding: 0.2rem 0.32rem;
    }
    .wrapper {
      padding-left: 0.32rem;
      min-height: 2rem;
      .cont {
        list-style: none;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        overflow: -moz-scrollbars-none;
        overflow: -moz-scrollbars-none;
        margin-bottom: -0.2rem;
        font-size: 12px;
        text-align: center;
        padding-right: 0.24rem;
        display: flex;
        .cont-item {
          position: relative;
          display: inline-block;
          padding: 0.06rem 0 0.35rem;
          width: 2rem;
          margin-right: 0.8rem;
          justify-items: flex-start;
          .cont-img {
            overflow: hidden;
            width: 2.4rem;
            height: 2.4rem;
            // padding-bottom: 100%;
            .img {
              // width: 100%;
              width: 2.4rem;
              height: 2.4rem;
              border-radius: 0.16rem;
            }
          }
        }
      }
    }

    .cont ::-webkit-scrollbar {
      display: none;
    }
  }
  .task-card::after {
    content: "";
    display: block;
    border: 0.001rem solid rgb(229, 229, 229);
    width: 90%;
    margin: 0.4rem auto 0;
  }
  //   在招职位
  .position {
    padding: 0.2rem 0.36rem;
    .pos-item {
      padding: 0.24rem 0;
      .pos-top {
        display: flex;
        justify-content: space-between;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 0.5rem;
        color: rgba(51, 51, 51, 1);
        span:first-child{
          width: 70%;
        }
        span:last-child {
          font-size: 0.32rem;
          color: rgba(255, 67, 67, 1);
        }
      }
      .pos-bits {
        margin-top: 0.15rem;
        display: flex;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
        span {
          display: flex;
          align-items: center;
        }

        span::after {
          content: "";
          display: block;
          height: 0.3rem;
          width: 0.02rem;
          background: #e6e6e6;
          margin: 0 0.2rem;
        }
        span:last-child::after {
          display: none;
        }
      }
    }
  }
}
</style>